
import logo from '../../assets/images/logo.svg';

const LoginHeader = () => {

    return(
        <header>
            <div className="content-section">
                <div className="logo flex gap-10">
                    <div className="icon logo-icon">
                        <img src={logo} alt=""/>
                    </div>
                    <div className="sf-bold font-16">
                        Onboard Fleet<br/> Services
                    </div>
                </div>
            </div>
        </header>
    )

}

export default LoginHeader;
